class ProductFormSticky extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    this.toggler = this.querySelector('.product-sticky__toggler');
    this.stickyEl = this.querySelector('.product-sticky');
    this.thresholdTop = this.toggler.getBoundingClientRect().top + window.scrollY;
    window.addEventListener('rwd:width-change', function () {
      _this.thresholdTop = _this.toggler.getBoundingClientRect().top + window.scrollY;
    });
    window.addEventListener('scroll', this.onScroll.bind(this));
    this.onScroll();
  }
  onScroll() {
    const _this = this;
    if (window.scrollY > this.thresholdTop) {
      requestAnimationFrame(() => {
        _this.stickyEl.classList.remove('hide-bottom');
      });
    } else {
      requestAnimationFrame(() => {
        _this.stickyEl.classList.add('hide-bottom');
      });
    }
  }
}

customElements.define('product-form-sticky', ProductFormSticky);
